import moduleName from './description';
import Description from './description';
import Receive from './receive';

export default {
  Description,
  Receive,
};
